import { Directive, HostListener, ElementRef, inject, OnInit } from "@angular/core";
import { FormGroupDirective } from "@angular/forms";
import { fromEvent } from "rxjs";
import { debounceTime, take } from "rxjs/operators";


/**
 * Une directive qui peut être utilisé dans l'element html <form>
 * Exemple : <form [formGroup]="dataForm" (ngSubmit)="onSubmit()" appInvalidControlScroll>
 **/
@Directive({
    selector: "[appInvalidControlScroll]"
})
export class InvalidControlScrollDirective implements OnInit {
  private el = inject(ElementRef);
  private formGroupDir = inject(FormGroupDirective);


  ngOnInit(): void {
      console.log("invalid scroll");
  }
  @HostListener("ngSubmit") onSubmit() {
    console.log("formGroupDir.control", this.formGroupDir.control);
    if (this.formGroupDir.control.invalid) {
      this.scrollToFirstInvalidControl();
    }
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      ".ng-invalid"
    );

    window.scroll({
      top: this.getTopOffset(firstInvalidControl) ?? 0,
      left: 0,
      behavior: "smooth"
    });

    fromEvent(window, "scroll")
      .pipe(
        debounceTime(100),
        take(1)
      )
      .subscribe(() => firstInvalidControl.focus());
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 100;
    return controlEl?.getBoundingClientRect()?.top + window.scrollY - labelOffset;
  }
}